<ag-grid-angular
  data-testid="broadcast-notifications-table"
  class="ag-theme-quartz margin-top-med margin-bottom-med"
  [tooltipShowDelay]=0
  domLayout='autoHeight'
  [rowHeight]="50"
  rowClass="table-row"
  (firstDataRendered)="onFirstDataRendered($event)"
  (gridSizeChanged)="gridSizeChanged($event)"
  overlayNoRowsTemplate="<span>No notifications found</span>"
  [rowData]="notifications"
  [columnDefs]="broadcastNotificationColDefs">
</ag-grid-angular>
